import {
    FETCH_COMMISSIONS_REQUEST,
    FETCH_COMMISSIONS_SUCCESS,
    FETCH_COMMISSIONS_FAILURE,
    ADD_COMMISSION_REQUEST,
    ADD_COMMISSION_SUCCESS,
    ADD_COMMISSION_FAILURE,
    UPDATE_COMMISSION_REQUEST,
    UPDATE_COMMISSION_SUCCESS,
    UPDATE_COMMISSION_FAILURE,
    DELETE_COMMISSION_REQUEST,
    DELETE_COMMISSION_SUCCESS,
    DELETE_COMMISSION_FAILURE,
  } from './types';
  
  import {
    fetchCommissions,
    createCommission,
    updateCommission,
    deleteCommission,
  } from '../../services/driverCommissionService';
  
  // Action Creators
  export const fetchCommissionsRequest = () => ({ type: FETCH_COMMISSIONS_REQUEST });
  export const fetchCommissionsSuccess = (commissionsData) => ({
    type: FETCH_COMMISSIONS_SUCCESS,
    payload: commissionsData,
  });
  export const fetchCommissionsFailure = (error) => ({
    type: FETCH_COMMISSIONS_FAILURE,
    payload: error,
  });
  
  // Add Commission Action Creators
  export const addCommissionRequest = () => ({ type: ADD_COMMISSION_REQUEST });
  export const addCommissionSuccess = (commissionData) => ({
    type: ADD_COMMISSION_SUCCESS,
    payload: commissionData,
  });
  export const addCommissionFailure = (error) => ({
    type: ADD_COMMISSION_FAILURE,
    payload: error,
  });
  
  // Update Commission Action Creators
  export const updateCommissionRequest = () => ({ type: UPDATE_COMMISSION_REQUEST });
  export const updateCommissionSuccess = (commissionData) => ({
    type: UPDATE_COMMISSION_SUCCESS,
    payload: commissionData,
  });
  export const updateCommissionFailure = (error) => ({
    type: UPDATE_COMMISSION_FAILURE,
    payload: error,
  });
  
  // Delete Commission Action Creators
  export const deleteCommissionRequest = () => ({ type: DELETE_COMMISSION_REQUEST });
  export const deleteCommissionSuccess = (commissionId) => ({
    type: DELETE_COMMISSION_SUCCESS,
    payload: commissionId,
  });
  export const deleteCommissionFailure = (error) => ({
    type: DELETE_COMMISSION_FAILURE,
    payload: error,
  });
  
  // Thunk to fetch commissions
  export const fetchCommissionsAction = (filterField, filterValue, page = 1, size = 50) => async (dispatch) => {
    dispatch(fetchCommissionsRequest());
  
    try {
      const response = await fetchCommissions(filterField, filterValue, page, size);
  
      if (response.error) {
        dispatch(fetchCommissionsFailure(response.error));
        return { success: false, error: response.error };
      } else {
        dispatch(fetchCommissionsSuccess(response));
        return { success: true, data: response };
      }
    } catch (error) {
      dispatch(fetchCommissionsFailure(error.message || "Failed to fetch commissions"));
      return { success: false, error: error.message || "Failed to fetch commissions" };
    }
  };
  
  // Thunk to create a new commission
  export const addCommissionAction = (commissionData) => async (dispatch) => {
    dispatch(addCommissionRequest());
  
    try {
      const response = await createCommission(commissionData);
  
      if (response.error) {
        dispatch(addCommissionFailure(response.error));
        return { success: false, error: response.error };
      } else {
        dispatch(addCommissionSuccess(response));
        return { success: true, data: response };
      }
    } catch (error) {
      dispatch(addCommissionFailure(error.message || "Failed to add commission"));
      return { success: false, error: error.message || "Failed to add commission" };
    }
  };
  
  // Thunk to update an existing commission
  export const updateCommissionAction = (commissionId, commissionData) => async (dispatch) => {
    dispatch(updateCommissionRequest());
  
    try {
      const response = await updateCommission(commissionId, commissionData);
  
      if (response.error) {
        dispatch(updateCommissionFailure(response.error));
        return { success: false, error: response.error };
      } else {
        dispatch(updateCommissionSuccess(response));
        return { success: true, data: response };
      }
    } catch (error) {
      dispatch(updateCommissionFailure(error.message || "Failed to update commission"));
      return { success: false, error: error.message || "Failed to update commission" };
    }
  };
  
  // Thunk to delete a commission
  export const deleteCommissionAction = (commissionId) => async (dispatch) => {
    dispatch(deleteCommissionRequest());
  
    try {
      const response = await deleteCommission(commissionId);
  
      if (response.error) {
        dispatch(deleteCommissionFailure(response.error));
        return { success: false, error: response.error };
      } else {
        dispatch(deleteCommissionSuccess(commissionId));
        return { success: true, data: response };
      }
    } catch (error) {
      dispatch(deleteCommissionFailure(error.message || "Failed to delete commission"));
      return { success: false, error: error.message || "Failed to delete commission" };
    }
  };
  